import { Room } from '../libs/gs-component-hotel-planner';

import { Wws_CreateAccommodationItemAttrs } from '../generated/graphql';
import { ImageResult } from './images/mediaApiUtils';

const buildHotelPlannerId = (propertyId: string): number | undefined => {
  const number = Number.parseInt(propertyId);

  if (isNaN(number)) {
    return undefined;
  }

  return number;
};

/**
 * Returns the mutation attributes from hotel planner room
 * @param pageId number
 * @param param1 Room from hotel planner component
 */
export const mapRoomToPageItem = (
  pageId: number,
  { propertyId, propertyName, description = '', address1, city, stateCode, country, profileUrl, provider }: Room,
  image?: ImageResult
): Wws_CreateAccommodationItemAttrs => ({
  pageId,
  hotelPlannerId: buildHotelPlannerId(propertyId),
  hotelId: propertyId,
  address: [address1, city, stateCode, country].filter(val => val).join(', '),
  name: propertyName,
  description: description || null,
  website: profileUrl,
  photo: {
    mediaApiId: image?.mediaApiId || null,
    width: image?.width || null,
    height: image?.height || null,
  },
  provider: provider || null,
});
